export const tableOption = {
  align: 'center',
  menuAlign: 'center',
  border: true,
  stripe: true,
  columnBtn: false,
  refreshBtn: false,
  saveBtn: false,
  updateBtn: false,
  cancelBtn: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  selection: true,
  selectClearBtn: false,
  column: [
    {
      label: '名称',
      prop: 'name',
      solt: true,
      width: 420,
    },
    {
      label: '标签分组',
      prop: 'groupId',
      hide: true,
    },
    {
      label: '标签',
      prop: 'tagId',
      hide: true,
    },
    {
      label: '素材标签',
      prop: 'tagName',
      solt: true,
    },
    {
      label: '创建人',
      prop: 'creator',
    },
    {
      label: '上传时间',
      prop: 'insertedTime',
      sortable: true,
    }
  ]
}

export const materialType = {
  PICTURE: 1,
  VIDEO: 2,
  AUDIO: 3,
  DOCUMENT: 4,
}

export const materialTypeList = [
  {
    value: 1,
    type: "picture",
    extensions: [
      "bmp",
      "jpg",
      "jpeg",
      "png",
      "tif",
      "gif",
      "pcx",
      "tga",
      "exif",
      "fpx",
      "svg",
      "psd",
      "cdr",
      "pcd",
      "dxf",
      "ufo",
      "eps",
      "ai",
      "raw",
      "wmf",
      "webp",
      "avif"
    ]
  },
  {
    value: 2,
    type: "video",
    extensions: [
      "wmv",
      "asf",
      "asxrm",
      "rmvb",
      "mp4",
      "3gp",
      "mov",
      "m4v",
      "avi",
      "dat",
      "mkv",
      "flv",
      "vob"
    ]
  },
  {
    value: 3,
    type: "audio",
    extensions: [
      "cd",
      "wave",
      "aiff",
      "mpeg",
      "mp3",
      "mpeg-4",
      "midi",
      "wma",
      "realaudio",
      "vqf",
      "oggvorbis",
      "amr",
      "ape",
      "flac",
      "aac"
    ]
  },
  {
    value: 4,
    type: "document",
    extensions: []
  }
]